<template>
  <card-seplag>
    <div class="p-grid p-col-12" style="margin-top: 10px">
      <Rotulo cols="12 3" nome="Setor:">
        <Dropdown v-model="unidadeSelecionada" :options="listaUnidades" optionLabel="labelDropDaw"
          placeholder="Selecione..." filter :disabled="false" @change="carregarDados()" />
      </Rotulo>
      <Rotulo cols="12 4" nome="Situação">
        <Dropdown v-model="situacaoSelecionada" :options="situacoes" optionLabel="label" placeholder="Selecione..."
          showClear />
      </Rotulo>
      <div class="p-md-2 p-col-12">
        <Button label="Buscar" icon="pi pi-search" class="p-button-info" @click="clicouBuscar()" />
      </div>
    </div>
    <div class="p-grid p-col-12" style="margin-top: 10px">
      <h1 class="p-col-12">Férias Pendentes de Validação</h1>
    </div>
    <DataTable :value="dadosTabelaPendentes" :paginator="true" :rows="10" responsiveLayout="scroll"
      class="p-datatable-responsive table-seplag" style="width: 100%">
      <Column field="matricula" header="Matrícula" :headerStyle="`width: 3%;`"></Column>
      <Column field="nome" header="Nome"></Column>
      <Column field="setor" header="Setor"></Column>
      <Column header="Período de Aquisitivo" headerStyle="width: 14em" bodyStyle="text-align: center;">
        <template #body="slotProps">
          {{
            slotProps.data.dataInicioDireitoAfastamento
              ? slotProps.data.dataInicioDireitoAfastamento +
              " à " +
              slotProps.data.dataFimDireitoAfastamento
              : ""
          }}
          {{
            slotProps.data.dataInicioPeriodoAquisitivo
              ? slotProps.data.dataInicioPeriodoAquisitivo +
              " à " +
              slotProps.data.dataFimPeriodoAquisitivo
              : ""
          }}
        </template>
      </Column>
      <Column headerStyle="width: 14em" bodyStyle="text-align: center" header="Período de Usufruto">
        <template #body="slotProps">
          <span>{{ slotProps.data.dataInicio }} à
            {{ slotProps.data.dataFim }}</span><br />
          <span v-if="slotProps.data.dataInicioTemporario">Alterado para {{ slotProps.data.dataInicioTemporario }} à
            {{ slotProps.data.dataFimTemporario }}</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em; text-align: center" header="Dias de Afastamento">
        <template #body="slotProps">
          <div style="text-align: center">
            <span>{{
              slotProps.data.totalDias
                ? slotProps.data.totalDias
                : slotProps.data.dias
                  ? slotProps.data.dias
                  : ""
            }}
              dias <br /></span>
            <span v-if="slotProps.data.tipoJornada == 'REDUZIDA'">(<b>Redução de Jornada</b>)</span>
            <span v-if="slotProps.data.tipoJornada == 'INTEGRAL'">(<b>Usufruto</b>)</span><br />
            <span><b>{{
              slotProps.data.tipo
                ? slotProps.data.tipo
                : slotProps.data.title
                  ? slotProps.data.title.toUpperCase()
                  : ""
            }}</b></span>
          </div>
        </template>
      </Column>
      <Column headerStyle="width: 9em" bodyStyle="text-align: center" header="Status">
        <template #body="slotProps">
          <span v-if="!slotProps.data.conflito" class="customer-badge-aguardando">Aguardando</span>
          <span v-else class="customer-badge-conflito">Conflito</span>
        </template>
      </Column>

      <Column headerStyle="width: 9em" bodyStyle="text-align: center">
        <template #header>
          <div class="tipo-header">
            <span>Tipo</span>

            <span class="tipo-badge tipo-badge-n" v-tooltip="'Novo'">N</span>
            <span class="tipo-badge tipo-badge-a" v-tooltip="'Alterado'">A</span>
          </div>
        </template>

        <template #body="slotProps">
          <span v-if="!slotProps.data.dataInicioTemporario" class="tipo-badge tipo-badge-n">
            N
          </span>

          <span v-else class="tipo-badge tipo-badge-a"> A </span>
        </template>
      </Column>

      <Column headerStyle="width: 6em" bodyStyle="text-align: center;" header="Ação">
        <template #body="slotProps">
          <Button type="button" icon="pi pi-id-card" v-tooltip.top="'Aprovação'" @click="showModal(slotProps.data)"
            :disabled="slotProps.data.situacao == 'ENCERRADO'" />
        </template>
      </Column>
    </DataTable>

    <cadastro-rapido tituloTela="Aprovação" v-model="exibirTela" :modoEdicao="modoEdicao" :onAdicionar="validaRegistro"
      :onfecharModal="fecharModalValidaEscala" optionValue="code" :textoButton="'Salvar'">
      <div class="p-col-12">
        <Fieldset>
          <template #legend>
            <strong>Servidor</strong>
          </template>
          <p>
            <strong>Matricula: </strong>
            {{ dadosAprovacao.matricula ? dadosAprovacao.matricula : "" }}
          </p>
          <p>
            <strong>Candidato: </strong>
            {{ dadosAprovacao.nome ? dadosAprovacao.nome : "" }}
          </p>
          <p>
            <strong>Periodo de Usufruto: </strong>
            {{ dadosAprovacao.dataInicio ? dadosAprovacao.dataInicio : "" }} à
            {{ dadosAprovacao.dataFim ? dadosAprovacao.dataFim : "" }}
          </p>
          <p v-if="dadosAprovacao.dataInicioTemporario">
            <strong>Alterado para </strong>{{ dadosAprovacao.dataInicioTemporario }} à
            {{ dadosAprovacao.dataFimTemporario }}
          </p>
        </Fieldset>
      </div>
      <Rotulo nome="Deferido" cols="12">
        <SelectButton name="deferido" v-model="registro.statusProgramacao" :options="simNao" optionLabel="name"
          v-required />
      </Rotulo>
      <Rotulo nome="Justificativa" cols="12">
        <Textarea v-model="registro.observacaoTemporaria" rows="5" cols="30" />
      </Rotulo>
    </cadastro-rapido>
  </card-seplag>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import CadastroRapido from "@/template/CadRapidoSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { simNao } from "@/config/global";
import { baseApiUrl } from "@/config/global";

const getDefaultState = () => {
  return {
    chave: null,
    idReg: null,
    dataInicio: null,
    dataFim: null,
    qtdDiasAfastamento: null,
    matricula: null,
    numeroVinculo: null,
    observacaoTemporaria: "",
    matriculaAprovador: null,
    numeroVinculoAprovador: null,
    statusProgramacao: { name: "Não", code: "N" },
  };
};

export default {
  name: "feriasChefiaPendenteValidacao",
  components: { CardSeplag, CadastroRapido, Rotulo },
  data: function () {
    return {
      exibirTela: false,
      apiUrlRecurso: "feriasview",
      urlPaginacao: null,
      totalRegistro: 0,
      tamanhoPorpagina: 1000,
      paginacaoTabela: "?size=10&page=0",
      dadosTabelaPendentes: [],
      dadosAprovacao: [],
      simNao: simNao,
      registro: getDefaultState(),
      modoEdicao: "adicionar",
      habilitaAgendamento: true,
      listaUnidades: null,
      unidadeSelecionada: null,
      situacoes: [
        { label: "Pendente", value: "PENDENTE" },
        { label: "Validado", value: "APROVADO" },
        { label: "Acumulado", value: "ACUMULADO" },
      ],
      situacaoSelecionada: null,
      situacaoConsultada: null,
      matriculaChefe: null,
      vinculoChefe: null,
    };
  },
  methods: {
    async carregarDados() {
      this.matriculaChefe = this.$store.getters.getMatricula;
      this.vinculoChefe = this.$store.getters.getVinculo;

      // Buscar unidades
      await this.$http
        .get(
          `${baseApiUrl}/lincencaview/chefia/hierarquiaUnidades/${this.matriculaChefe}/${this.vinculoChefe}`,
        )
        .then((respUnidades) => {
          this.listaUnidades = respUnidades.data.map(function (element) {
            return {
              ...element,
              labelDropDaw: element.codgSeap + " - " + element.siglUnidade,
            };
          });
        });

      this.unidadeSelecionada = this.unidadeSelecionada
        ? this.unidadeSelecionada
        : this.listaUnidades[0];
    },
    clicouBuscar() {
      if (!this.unidadeSelecionada) {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Setor Obrigatório, Por favor Selecione um Setor",
          life: 3000,
        });
        return;
      }
      if (!this.situacaoSelecionada) {
        this.$toast.add({
          severity: "error",
          summary: "Seleção de Situação Obrigatória, Por favor Selecione uma Situação",
          life: 3000,
        });
        return;
      }
      this.situacaoConsultada = this.situacaoSelecionada.value;
      this.$http
          .get(
              `${baseApiUrl}/feriasview/chefia/lista/${this.situacaoConsultada}/${this.matriculaChefe}/${this.vinculoChefe}/${this.unidadeSelecionada.codgSeap}?size=${this.tamanhoPorpagina}&page=0`,
          )
          .then((res) => {
            this.dadosTabelaPendentes = res.data.content;
            this.totalRegistro = res.data.totalElements;
          });
    },
    showModal(dados) {
      this.registro.observacaoTemporaria = "";
      this.registro.chave = dados.chave;
      this.registro.idReg = dados.idReg;
      this.registro.dataInicio = dados.dataInicio;
      this.registro.dataFim = dados.dataFim;
      this.registro.qtdDiasAfastamento = dados.totalDias;
      this.registro.matricula = dados.matricula;
      this.registro.numeroVinculo = dados.numeroVinculo;
      this.dadosAprovacao = dados;
      this.exibirTela = true;
    },
    validaRegistro() {
      if (
        this.registro.statusProgramacao.code == "N" &&
        this.registro.observacaoTemporaria.trim() == ""
      ) {
        this.$toast.add({
          severity: "error",
          summary:
            "A justificativa é OBRIGATORIA quando o pedido de Férias for negado",
          life: 3000,
        });
        return;
      }
      if (this.dadosAprovacao.tipoAfastamento == 2) {
        let registroLP = {
          direitoAfastamento: {
            idenDireitoAfastamento: this.dadosAprovacao.idenDireitoAfastamento,
          },
          descJustificativa: this.registro.observacaoTemporaria,
          numrMatriculaChefe: this.$store.getters.getMatricula,
          numrVinculoChefe: this.$store.getters.getVinculo,
          statusProgramacao: {
            idenStatusProgramacao: { name: "Sim", code: "S" },
          },
        };
        if (this.registro.statusProgramacao.code == "S") {
          registroLP.statusProgramacao.idenStatusProgramacao = 2; // aprovado
        } else {
          registroLP.statusProgramacao.idenStatusProgramacao = 3; // reprovado
        }

        this.$http
          .put(
            `${baseApiUrl}/programacaoafastamentos/validacao/${this.dadosAprovacao.idenProgramacaoAfastamento}/${this.$store.getters.getUser.dadosUsuariosCustomizados.matricula}/${this.$store.getters.getUser.dadosUsuariosCustomizados.vinculoSeap.vinculo}`,
            JSON.stringify(registroLP),
          )
          .then(() => {
            if (this.registro.statusProgramacao.idenStatusProgramacao == 2) {
              this.$toast.add({
                severity: "success",
                summary:
                  "Agendamento aprovado com Sucesso! Informações encaminhadas por email",
                life: 3000,
              });
            }
            this.carregarDados();
            this.exibirTela = false;
          });
      } else {
        let situacao = "";
        if (this.registro.statusProgramacao.code == "S") {
          situacao = "APROVADO";
        } else {
          situacao = "REPROVADO";
        }
        let jsonBody = {
          ...this.registro,
          matriculaAprovador: this.$store.getters.getMatricula,
          numeroVinculoAprovador: this.$store.getters.getVinculo,
        };
        this.$http
          .put(
            `${baseApiUrl}/feriasview/chefia/acao/${situacao}`,
            JSON.stringify(jsonBody),
          )
          .then(() => {
            if (this.registro.statusProgramacao.code == "S") {
              this.$toast.add({
                severity: "success",
                summary:
                  "Agendamento aprovado com Sucesso! Informações encaminhadas por email",
                life: 3000,
              });
            }
            this.carregarDados();
            this.exibirTela = false;
          });
      }
    },
    fecharModalValidaEscala() {
      this.exibirTela = false;
    },
  },
  mounted() {
    // Carrega os dados do serviço
    this.carregarDados();
  },
};
</script>

<style>
.customer-badge-aguardando {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background-color: #c8e6c9;
  color: #256029;
}

.customer-badge-conflito {
  border-radius: 2px;
  padding: 0.25em 0.5em;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  background-color: #ffcdd2;
  color: #c63737;
}

.tipo-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.tipo-header span:first-child {
  font-weight: 600;
  color: #555;
}

.tipo-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
}

.tipo-badge-n {
  color: #019722;
  background-color: #eeffef;
  border: 1px solid #93f990;
}

.tipo-badge-a {
  color: #f57c00;
  background-color: #fff7ed;
  border: 1px solid #ffcc80;
}
</style>
